import React from 'react'
import { SectionTitle, ItemTitle, Tabs } from '../../../../components'

import data from './data.json'

import './style.scss'

const Changelog = () =>
  data.changelog.map(e => (
    <div>
      <SectionTitle>{e.date}</SectionTitle>
      <Tabs>
        <div label="CurrencySCSS">
          <div class="changelog">
            {e.version && <p>Currency v{e.version}</p>}
            {e.scss.version && <p>{e.scss.version}</p>}
            {e.scss.new && (
              <>
                <ItemTitle>New</ItemTitle>

                <ul>
                  {e.scss.new.map(item => (
                    <li>{item}</li>
                  ))}
                </ul>
              </>
            )}

            {e.scss.improved && (
              <>
                <ItemTitle>Improved</ItemTitle>
                <ul>
                  {e.scss.improved.map(item => (
                    <li>{item}</li>
                  ))}
                </ul>
              </>
            )}
            {e.scss.fixed && (
              <>
                <ItemTitle>Fixed</ItemTitle>
                <ul>
                  {e.scss.fixed.map(item => (
                    <li>{item}</li>
                  ))}
                </ul>
              </>
            )}
          </div>
        </div>
        {e.doc && (
          <div label="Documentation Site">
            <div class="changelog">
              {e.version && <p>Currency v{e.version}</p>}
              {e.doc.version && <p>{e.doc.version}</p>}
              {e.doc.new && (
                <>
                  <ItemTitle>New</ItemTitle>
                  <ul>
                    {e.doc.new.map(item => (
                      <li>{item}</li>
                    ))}
                  </ul>
                </>
              )}

              {e.doc.improved && (
                <>
                  <ItemTitle>Improved</ItemTitle>
                  <ul>
                    {e.doc.improved.map(item => (
                      <li>{item}</li>
                    ))}
                  </ul>
                </>
              )}
              {e.doc.fixed && (
                <>
                  <ItemTitle>Fixed</ItemTitle>
                  <ul>
                    {e.doc.fixed.map(item => (
                      <li>{item}</li>
                    ))}
                  </ul>
                </>
              )}
            </div>
          </div>
        )}
        {e.dsm && (
          <div label="DSM">
            <div class="changelog">
              {e.version && <p>Currency v{e.version}</p>}
              {e.dsm.version && <p>{e.dsm.version}</p>}
              {e.dsm.new && (
                <>
                  <ItemTitle>New</ItemTitle>
                  <ul>
                    {e.dsm.new.map(item => (
                      <li>{item}</li>
                    ))}
                  </ul>
                </>
              )}

              {e.dsm.improved && (
                <>
                  <ItemTitle>Improved</ItemTitle>
                  <ul>
                    {e.dsm.improved.map(item => (
                      <li>{item}</li>
                    ))}
                  </ul>
                </>
              )}
              {e.dsm.fixed && (
                <>
                  <ItemTitle>Fixed</ItemTitle>
                  <ul>
                    {e.dsm.fixed.map(item => (
                      <li>{item}</li>
                    ))}
                  </ul>
                </>
              )}
            </div>
          </div>
        )}
        {e.figma && (
          <div label="Figma">
            <div class="changelog">
              {e.version && <p>Currency v{e.version}</p>}
              {e.figma.version && <p>{e.figma.version}</p>}
              {e.figma.new && (
                <>
                  <ItemTitle>New</ItemTitle>
                  <ul>
                    {e.figma.new.map(item => (
                      <li>{item}</li>
                    ))}
                  </ul>
                </>
              )}

              {e.figma.improved && (
                <>
                  <ItemTitle>Improved</ItemTitle>
                  <ul>
                    {e.figma.improved.map(item => (
                      <li>{item}</li>
                    ))}
                  </ul>
                </>
              )}
              {e.figma.fixed && (
                <>
                  <ItemTitle>Fixed</ItemTitle>
                  <ul>
                    {e.figma.fixed.map(item => (
                      <li>{item}</li>
                    ))}
                  </ul>
                </>
              )}
            </div>
          </div>
        )}
      </Tabs>
    </div>
  ))

export default Changelog
